import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class TableTextInput extends React.Component {
    state = {
    }

    componentDidMount() {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        let styleInfo = this.props.styleInfo
        let info = this.props.header?.information
        return (
            <div className="w-100 h-100 flexcc">
                {this.props.data && (
                    // <p className="text-small" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{String(this.props.data)}</p>
                    <p className="" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }}>{this.props.data != null ? (String(this.props.data).substr(0, 40) + (String(this.props.data).length > 40 ? ' ...' : '')) : ' '}</p>
                )}
            </div>
        )
    }
}

export default TableTextInput;